import type { Movie } from '@/mocks/movies';
import { typeLabels } from '@/mocks/movies';

export function formatViews(views: number): string {
  if (views >= 100000000) return `${(views / 100000000).toFixed(1)}亿`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function typeLabel(type: string): string {
  return typeLabels[type] ?? type;
}

export function getByType(list: Movie[], type: string): Movie[] {
  return list.filter((m) => m.type === type);
}

export function getFeatured(list: Movie[]): Movie[] {
  return list.filter((m) => m.featured);
}

export function getLatest(list: Movie[], count = 12): Movie[] {
  return [...list].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, count);
}

export function getHot(list: Movie[], count = 10): Movie[] {
  return [...list].sort((a, b) => b.views - a.views).slice(0, count);
}

export function findById(list: Movie[], id: string): Movie | undefined {
  return list.find((m) => m.id === id);
}

/** 同分类或同主演的相关推荐 */
export function getRelated(list: Movie[], current: Movie, count = 6): Movie[] {
  const sameType = list.filter((m) => m.id !== current.id && m.type === current.type);
  const sameCast = list.filter(
    (m) => m.id !== current.id && m.cast.some((c) => current.cast.includes(c)),
  );
  const merged = [...sameCast, ...sameType].filter(
    (m, i, arr) => arr.findIndex((x) => x.id === m.id) === i,
  );
  return merged.slice(0, count);
}